// extracted by mini-css-extract-plugin
export default {"rowTextarea":"_Textarea_rowTextarea__AmP-h","attachmentBtn":"_Textarea_attachmentBtn__MZKpj","textarea":"_Textarea_textarea__u9sCk"};